import MaskingPolicyActions, { maskingPolicyActionTypes } from '@Actions/settings/maskingPolicyActions';
import TrackerActions from '@Actions/trackerActions';
import {
  put, takeLatest, all,
} from 'redux-saga/effects';
import MaskingPolicyService from '@Services/settings/maskingPolicyServices';
import { notification } from 'antd';

/**
 * @param action
 */
function* _createMaskingPolicy(action) {
  try {
    yield put(MaskingPolicyActions.createMaskingPolicyLoading(true));
    const { payload } = action;
    const maskingPolicy = yield MaskingPolicyService.createMaskingPolicy(payload);
    if (!maskingPolicy.success) {
      notification.open({
        type: 'error',
        message: maskingPolicy?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(TrackerActions.trackAction(maskingPolicyActionTypes.CREATE_MASKING_POLICY.SUCCESS, maskingPolicy.data));
      notification.open({
        type: 'success',
        message: 'Masking Policy created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback(maskingPolicy.maskingPolicy);
      }
    }
    yield put(MaskingPolicyActions.createMaskingPolicyLoading(false));
  } catch (error) {
    yield put(MaskingPolicyActions.createMaskingPolicyLoading(false));
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(maskingPolicyActionTypes.CREATE_MASKING_POLICY.ERROR, error));
  }
}

/**
 *
 */
function* createMaskingPolicy() {
  yield takeLatest(maskingPolicyActionTypes.CREATE_MASKING_POLICY.REQUEST, _createMaskingPolicy);
}

/**
 * @param action
 */
function* _getMaskingPolicyById(action) {
  try {
    yield put(MaskingPolicyActions.getMaskingPolicyByIdLoading(true));
    const selectedMaskingPolicy = yield MaskingPolicyService.getMaskingPolicyById(action.orgId, action.maskingPolicyId);
    yield put(MaskingPolicyActions.getMaskingPolicyByIdSuccess(selectedMaskingPolicy?.maskingPolicys?.[0]));
    yield put(MaskingPolicyActions.getMaskingPolicyByIdLoading(false));
  } catch (error) {
    yield put(MaskingPolicyActions.getMaskingPolicyByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(maskingPolicyActionTypes.GET_MASKING_POLICY_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getMaskingPolicyById() {
  yield takeLatest(maskingPolicyActionTypes.GET_MASKING_POLICY_BY_ID.REQUEST, _getMaskingPolicyById);
}

/**
 * @param action
 */
function* _getMaskingPolicies(action) {
  try {
    yield put(MaskingPolicyActions.getMaskingPoliciesLoading(true));
    const maskingPolicies = yield MaskingPolicyService.getMaskingPolicies(action.orgId, action.maskingPolicyId, action.page, action.limit);
    yield put(MaskingPolicyActions.getMaskingPoliciesSuccess(maskingPolicies));
    yield put(MaskingPolicyActions.getMaskingPoliciesLoading(false));
    if (action.callback) {
      action.callback(maskingPolicies);
    }
  } catch (error) {
    yield put(MaskingPolicyActions.getMaskingPoliciesLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(maskingPolicyActionTypes.GET_MASKING_POLICIES.ERROR, error));
  }
}

/**
 *
 */
function* getMaskingPolicies() {
  yield takeLatest(maskingPolicyActionTypes.GET_MASKING_POLICIES.REQUEST, _getMaskingPolicies);
}

/**
 * @param action
 */
function* _updateMaskingPolicy(action) {
  try {
    yield put(MaskingPolicyActions.updateMaskingPolicyLoading(true));
    const { payload } = action;
    const updatedMaskingPolicy = yield MaskingPolicyService.updateMaskingPolicy(payload);
    if (!updatedMaskingPolicy.success) {
      yield put(TrackerActions.trackAction(maskingPolicyActionTypes.UPDATE_MASKING_POLICY.SUCCESS, updatedMaskingPolicy.data));
      notification.open({
        type: 'error',
        message: updatedMaskingPolicy.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      notification.open({
        type: 'success',
        message: 'MaskingPolicy update successful.',
        duration: 4,
        placement: 'top',
      });
      if (action.callback) {
        action.callback();
      }
    }
    yield put(MaskingPolicyActions.updateMaskingPolicyLoading(false));
  } catch (error) {
    yield put(MaskingPolicyActions.updateMaskingPolicyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(maskingPolicyActionTypes.UPDATE_MASKING_POLICY.ERROR, error));
  }
}

/**
 *
 */
function* updateMaskingPolicy() {
  yield takeLatest(maskingPolicyActionTypes.UPDATE_MASKING_POLICY.REQUEST, _updateMaskingPolicy);
}

/**
 * @param action
 */
function* _deleteMaskingPolicy(action) {
  try {
    yield put(MaskingPolicyActions.deleteMaskingPolicyLoading(true));
    const so = yield MaskingPolicyService.deleteMaskingPolicy(action.payload);

    if (so.success) {
      notification.open({
        type: 'success',
        message: 'MaskingPolicy successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MaskingPolicyActions.deleteMaskingPolicyLoading(false));
  } catch (error) {
    yield put(MaskingPolicyActions.deleteMaskingPolicyLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(maskingPolicyActionTypes.DELETE_MASKING_POLICY.ERROR, error));
  }
}

/**
 *
 */
function* deleteMaskingPolicy() {
  yield takeLatest(maskingPolicyActionTypes.DELETE_MASKING_POLICY.REQUEST, _deleteMaskingPolicy);
}

/**
 * @param action
 */
function* _getMaskingPolicyEditPage(action) {
  try {
    yield put(MaskingPolicyActions.getMaskingPolicyEditPageLoading(true));
    const maskingPolicyEditPage = yield MaskingPolicyService.getMaskingPolicyEditPage();
    yield put(MaskingPolicyActions.getMaskingPolicyEditPageSuccess(maskingPolicyEditPage));
    yield put(MaskingPolicyActions.getMaskingPolicyEditPageLoading(false));
  } catch (error) {
    yield put(MaskingPolicyActions.getMaskingPolicyEditPageLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(maskingPolicyActionTypes.MASKING_POLICY_EDIT_PAGE.ERROR, error));
  }
}

/**
 *
 */
function* getMaskingPolicyEditPage() {
  yield takeLatest(maskingPolicyActionTypes.MASKING_POLICY_EDIT_PAGE.REQUEST, _getMaskingPolicyEditPage);
}

/**
 *
 */
export default function* customerSaga() {
  yield all([createMaskingPolicy(), getMaskingPolicyById(), getMaskingPolicies(), updateMaskingPolicy(), deleteMaskingPolicy(), getMaskingPolicyEditPage()]);
}
